export default __webpack_public_path__ + "static/media/play-icon.59f186eb.svg";